$(document).ready(function () {
  var listUrl = $('#asset_url_hidden_field').val() + "&b=" + Math.floor(Math.random() * 1000);
  $.ajax({
        type: "GET",
        url: listUrl,
        dataType: "text",
        success: function (data) {
            var str = data;
            const rows = str.slice(str.indexOf("\n") + 1).split("\n");
            const headers = ['name', 'value'];
            const arr = rows.map(function (row) {
                const values = row.split(",").map(function (item) {
                    return item.trim();
                });
                const el = headers.reduce(function (object, header, index) {
                    object[header] = values[index];
                    return object;
                }, {});
                return el;
            });
            colors = arr;
            UpdateNames();
        }
    });

});

function UpdateNames() {
    $('variant-radios label, .product-option > dd, .facet-checkbox > span[aria-hidden=true]').each(function () {
        var txt = $(this).text().trim();
        let obj = colors.find(o => o.name === txt);
        if (obj) $(this).text(txt.replace(txt, obj.value.toUpperCase()));
    });
}